const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCollection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    id: "svg3991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fillOpacity: 1,
      strokeWidth: 0.06822924
    },
    d: "M 59.53125 2.5996094 C 57.313155 6.4665357 58.744977 10.724358 62.65625 12.496094 L 63.359375 12.816406 C 67.26264 14.605715 71.422315 12.890283 72.878906 8.6816406 C 69.827676 6.9306889 66.512026 7.4335699 64.376953 9.6523438 C 64.650574 6.5853156 62.854577 3.7534946 59.53125 2.5996094 z M 58.583984 14.044922 C 54.904296 14.011468 51.67865 16.375508 50.509766 19.769531 L 55.355469 21.978516 C 55.908632 22.23059 56.150946 22.875102 55.896484 23.421875 C 55.772447 23.694068 55.549132 23.894214 55.287109 23.992188 C 55.025086 24.090167 54.723348 24.086891 54.451172 23.962891 L 50.044922 21.953125 L 49.082031 31.96875 L 62.929688 30.183594 L 64.667969 28.351562 C 65.922173 27.03034 66.762455 25.289758 66.951172 23.339844 C 67.400414 18.677462 63.986601 14.533225 59.324219 14.083984 C 59.07534 14.06004 58.829297 14.047152 58.583984 14.044922 z ",
    id: "path3715"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3989",
    transform: "translate(-198.98305,-2.7118644)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fillOpacity: 1,
      strokeWidth: 0.10892374
    },
    d: "m 51.963223,53.994803 c -1.840811,0 -3.294755,0.131459 -4.231499,-1.437037 l -7.28174,-12.723052 -6.437016,12.352459 c -0.947636,1.579392 -1.75304,2.096464 -3.593852,2.096464 -0.490157,0 -2.462686,-0.343277 -2.931058,-0.484895 L 12.565506,49.528928 v 19.388428 c 0,1.601177 1.367181,3.273342 5.322752,4.303114 l 20.862515,4.966294 c 1.481615,-0.09828 2.183859,0.179661 3.376637,0 l 20.513703,-4.873647 c 3.862925,-1.040659 5.693349,-2.80548 5.693349,-4.395761 V 49.528928 l -16.371239,4.465875 c -0.468372,0.141599 0.490155,0 0,0 z",
    id: "path4020"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      strokeWidth: 0.10892374
    },
    d: "m 10.833239,32.707106 -3.3860144,6.84289 c -1.1495875,2.206526 -0.8011564,4.331174 3.2310404,5.747937 l 17.757429,5.13506 c 0.77336,0.217847 1.60118,-0.108921 2.015089,-0.795141 L 40.449984,33.081439 16.439953,30.25531 c -2.191531,-1.115672 -5.362037,0.598269 -5.606714,2.451796 z",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      strokeWidth: 0.10892374
    },
    d: "m 73.174804,39.920589 -2.27424,-7.120836 c -0.80091,-1.601809 -3.56896,-3.198358 -6.35879,-2.822388 l -24.09179,3.104074 9.9883,16.567303 c 0.41392,0.686223 1.24174,1.012994 2.01509,0.795147 l 18.59127,-5.135066 c 3.1166,-1.520302 3.1762,-2.440522 2.13016,-5.388234 z",
    id: "path4018"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fillOpacity: 1,
      strokeWidth: 0.06162028
    },
    d: "M 32.719217,9.6183226 A 1.5899227,1.376599 24.409852 0 0 31.46531,10.376135 l -2.458984,5.419922 -0.822266,-1.787109 c -0.415817,-0.904332 -1.637089,-1.561274 -2.728515,-1.238282 l -4.277344,1.263672 c -0.938989,0.276323 -1.554721,1.318149 -1.072265,2.363281 l 0.822265,1.789063 -6.261723,-2.841797 a 1.5899227,1.376599 24.409852 0 0 -2.01562,0.595703 1.8912812,1.6375233 24.409852 0 0 -0.10352,0.628907 l 0.64063,6.505859 c 0.0934,0.963501 0.96856,2.108927 1.95508,2.556641 l 6.298825,2.859374 c 0.175234,0.826354 0.403884,1.633864 0.662109,2.429688 l 8.433594,0.994141 a 2.6489144,2.293503 24.409852 0 1 4.154297,0.488281 l 5.757813,0.677734 0.339843,0.285156 c -0.03606,-3.373896 -1.599753,-6.499053 -3.822265,-9.470703 l 2.46875,-5.441406 c 0.386385,-0.853993 0.127227,-2.182304 -0.580078,-2.964844 L 34.068826,10.20426 A 1.8807291,1.6283872 24.409852 0 0 33.482889,9.780432 1.5899227,1.376599 24.409852 0 0 32.719217,9.6183226 Z",
    id: "path3735-3-7"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollection);
export default __webpack_public_path__ + "static/media/icon-collection.0e095b89.svg";
export { ForwardRef as ReactComponent };